import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { sectionOwn } from '../../../actions/section';
import OwnChoose from './OwnChoose';
import OwnWatch from './OwnWatch';
import OwnTrack from './OwnTrack';
import OwnClear from './OwnClear';
import { shadowSize } from '../../../utils/utils';

export class Own extends React.Component {
	componentDidMount() {
		this.props.sectionOwn();
		shadowSize();
	}
	render() {
        return (
			<div id="own" className="section">
			    <OwnChoose />
			    <OwnWatch />
			    <OwnTrack />
			    <OwnClear />
			</div>
		);
    }
};

const mapDispatchToProps = (dispatch) => ({
	sectionOwn: () => dispatch(sectionOwn())
});

export default connect(undefined, mapDispatchToProps)(Own);



// WEBPACK FOOTER //
// ./src/components/sections/own/Own.js